// ── Translations for Admin & Customer App ──
export const TRANSLATIONS = {
    en: {
        // ── Login ──
        login_title: "JB Admin",
        login_placeholder: "Enter password",
        login_btn: "Login",
        login_wrong: "Wrong password",

        // ── Header ──
        back: "← Back",
        dashboard: "Dashboard",
        settings: "Settings",
        order_details: "Order Details",
        new_manual_order: "New Manual Order",

        // ── Day strip ──
        day_started_at: "Day started at",
        day_not_started: "Day not started yet",
        start_day: "▶ Start Day",
        restart_day: "🔄 Restart Day",
        day_not_started_title: "Day not started",
        day_not_started_sub: "Tap \"Start Day\" above to begin taking orders",

        // ── Stat labels ──
        stat_all: "All",
        stat_new: "New",
        stat_approved: "Approved",
        stat_paid: "Paid",
        stat_preparing: "Preparing",
        stat_ready: "Ready",
        stat_complete: "Complete",
        stat_cancel: "Cancel",

        // ── Dashboard ──
        revenue: "Revenue",
        orders_completed: "orders completed",
        total_orders: "Total Orders",
        completed: "Completed",
        avg_order: "Avg. Order",
        pending: "Pending",
        popular_items: "🏆 Popular Items",
        show_all: "▼ Show All",
        items: "Items",
        show_less: "▲ Show Less",
        sold: "sold",
        current: "Current",
        no_sessions: "No sessions yet",
        no_orders_session: "No orders this session",
        day_not_started_dash: "⚠️ Day not started yet — tap Start Day to begin",
        all_orders: "All Orders",
        completed_orders: "Completed Orders",
        pending_orders: "Pending Orders",
        no_orders: "No orders",

        // ── Order detail ──
        total: "Total",
        order_complete: "✅ Order Complete",
        order_cancelled: "✕ Order Cancelled",
        manual_order: "Manual Order",

        // ── New Order / Cart ──
        customer_name_placeholder: "Customer name",
        cart: "🛒 Cart",
        placing: "Placing...",
        place_order: "Place Order",
        items_added: "items",
        in_stock: "✅ In Stock",
        out_of_stock: "❌ Out of Stock",
        sold_out: "Sold Out",

        // ── Alerts / Confirms ──
        alert_enter_name: "Enter customer name",
        alert_add_items: "Add items first",
        alert_cancel_order: "Cancel this order?",
        alert_start_day: "Start a new day? Token numbers will reset to #1.",
        alert_active_orders: "active order(s) are still active.\nPlease complete all orders first.",
        alert_cannot_start: "❌ Cannot start new day.\n\n",

        // ── Settings page ──
        settings_title: "Settings",
        settings_stock_section: "Stock Management",
        settings_stock_label: "Show In Stock / Out of Stock buttons",
        settings_stock_desc: "When enabled, stock toggle buttons appear in Manual Orders screen.",
        settings_lang_section: "Language / ભાષા",
        settings_lang_en: "English",
        settings_lang_gu: "ગુજરાતી",

        // ── Admin status labels ──
        status_new: "New",
        status_approved: "Approved",
        status_paid: "Paid",
        status_preparing: "Preparing",
        status_ready: "Ready",
        status_complete: "Complete",
        status_cancelled: "Cancelled",

        // ── Admin status action buttons ──
        action_approve: "✅ Approve",
        action_paid: "💰 Paid",
        action_prepare: "🍧 Prepare",
        action_ready: "🔔 Ready",
        action_complete: "✔ Complete",
        cancel_order: "✕ Cancel Order",

        // ── Customer — order status screen ──
        c_order_status: "Order Status",
        c_loading: "Loading your order...",
        c_live: "Live",
        c_now_making: "Now Making:",
        c_your_order: "Your Order",
        c_order_again: "🍧 Order Again",
        c_items_in_cart: "items added",
        c_view_cart: "View Cart",

        // Customer STATUS_CONFIG labels & descriptions
        cs_pending_label: "Order Placed",
        cs_pending_desc: "Waiting for shop to approve your order...",
        cs_approved_label: "Approved!",
        cs_approved_desc: "Please come to the counter and pay 💰",
        cs_paid_label: "Payment Done",
        cs_paid_desc: "Your order is being prepared!",
        cs_preparing_label: "Preparing...",
        cs_preparing_desc: "Your gola is being made fresh!",
        cs_ready_label: "Ready! 🔔",
        cs_ready_desc: "Come collect your order!",
        cs_complete_label: "Enjoy!",
        cs_complete_desc: "Thank you! Visit again 😊",
        cs_cancelled_label: "Cancelled",
        cs_cancelled_desc: "Your order was cancelled by the shop.",

        // Customer cart page
        c_your_cart: "Your Cart",
        c_add_items_btn: "Add Items",
        c_cart_empty: "Your cart is empty",
        c_your_name_label: "Your Name (for order)",
        c_name_placeholder: "Enter your name",
        c_place_order_btn: "Place Order",
        c_placing_order: "Placing Order...",
        c_pay_note: "💰 Pay at counter after approval",
    },

    gu: {
        // ── Login ──
        login_title: "JB એડમીન",
        login_placeholder: "પાસવર્ડ લખો",
        login_btn: "લૉગિન",
        login_wrong: "ખોટો પાસવર્ડ",

        // ── Header ──
        back: "← પાછળ",
        dashboard: "ડૅશબૉર્ડ",
        settings: "સેટિંગ",
        order_details: "ઑર્ડર વિગત",
        new_manual_order: "નવો મેન્યુઅલ ઑર્ડર",

        // ── Day strip ──
        day_started_at: "દિવસ શરૂ થયો",
        day_not_started: "દિવસ હજી શરૂ નથી",
        start_day: "▶ દિવસ શરૂ કરો",
        restart_day: "🔄 દિવસ ફરી શરૂ કરો",
        day_not_started_title: "દિવસ શરૂ નથી",
        day_not_started_sub: "ઑર્ડર લેવાનું શરૂ કરવા ઉપર \"દિવસ શરૂ કરો\" ટૅપ કરો",

        // ── Stat labels ──
        stat_all: "બધા",
        stat_new: "નવા",
        stat_approved: "મંજૂર",
        stat_paid: "ચૂકવ્યા",
        stat_preparing: "બનાવે છે",
        stat_ready: "તૈયાર",
        stat_complete: "પૂર્ણ",
        stat_cancel: "રદ",

        // ── Dashboard ──
        revenue: "આવક",
        orders_completed: "ઑર્ડર પૂર્ણ",
        total_orders: "કુલ ઑર્ડર",
        completed: "પૂર્ણ",
        avg_order: "સરેરાશ ઑર્ડર",
        pending: "બાકી",
        popular_items: "🏆 લોકપ્રિય આઇટમ",
        show_all: "▼ બધું જુઓ",
        items: "આઇટમ",
        show_less: "▲ ઓછું જુઓ",
        sold: "વેચ્યા",
        current: "ચાલુ",
        no_sessions: "કોઈ સત્ર નથી",
        no_orders_session: "આ સત્રમાં કોઈ ઑર્ડર નથી",
        day_not_started_dash: "⚠️ દિવસ શરૂ નથી — 'દિવસ શરૂ કરો' ટૅપ કરો",
        all_orders: "બધા ઑર્ડર",
        completed_orders: "પૂર્ણ ઑર્ડર",
        pending_orders: "બાકી ઑર્ડર",
        no_orders: "કોઈ ઑર્ડર નથી",

        // ── Order detail ──
        total: "કુલ",
        order_complete: "✅ ઑર્ડર પૂર્ણ",
        order_cancelled: "✕ ઑર્ડર રદ",
        manual_order: "મેન્યુઅલ ઑર્ડર",

        // ── New Order / Cart ──
        customer_name_placeholder: "ગ્રાહકનું નામ",
        cart: "🛒 કાર્ટ",
        placing: "મૂકાઈ રહ્યું છે...",
        place_order: "ઑર્ડર આપો",
        items_added: "આઇટમ",
        in_stock: "✅ ઉપલબ્ધ",
        out_of_stock: "❌ ઉપલબ્ધ નથી",
        sold_out: "સ્ટૉક ખૂટ્યો",

        // ── Alerts / Confirms ──
        alert_enter_name: "ગ્રાહકનું નામ લખો",
        alert_add_items: "પહેલાં આઇટમ ઉમેરો",
        alert_cancel_order: "આ ઑર્ડર રદ કરવો?",
        alert_start_day: "નવો દિવસ શરૂ કરો? ટોકન નંબર #1 થી ફરી શરૂ થશે.",
        alert_active_orders: "ઑર્ડર(ઓ) હજી ચાલુ છે.\nપહેલા બધા ઑર્ડર પૂર્ણ કરો.",
        alert_cannot_start: "❌ નવો દિવસ શરૂ નહિ થઈ શકે.\n\n",

        // ── Settings page ──
        settings_title: "સેટિંગ",
        settings_stock_section: "સ્ટૉક મૅનેજમૅન્ટ",
        settings_stock_label: "ઉપલબ્ધ / ઉપલબ્ધ નથી બટન બતાવો",
        settings_stock_desc: "ચાલુ હોય ત્યારે, મેન્યુઅલ ઑર્ડર સ્ક્રીનમાં સ્ટૉક ટૉગલ બટન દેખાશે.",
        settings_lang_section: "Language / ભાષા",
        settings_lang_en: "English",
        settings_lang_gu: "ગુજરાતી",

        // ── Admin status labels ──
        status_new: "નવો",
        status_approved: "✅ મંજૂર",
        status_paid: "💰 ચૂકવ્યો",
        status_preparing: "🍧 બનાવે છે",
        status_ready: "🔔 તૈયાર",
        status_complete: "✔ પૂર્ણ",
        status_cancelled: "✕ રદ",

        // ── Admin status action buttons ──
        action_approve: "✅ મંજૂર",
        action_paid: "💰 ચૂકવ્યો",
        action_prepare: "🍧 બનાવો",
        action_ready: "🔔 તૈયાર",
        action_complete: "✔ પૂર્ણ",
        cancel_order: "✕ ઑર્ડર રદ",

        // ── Customer — order status screen ──
        c_order_status: "ઑર્ડર સ્થિતિ",
        c_loading: "ઑર્ડર લોડ થઈ રહ્યો છે...",
        c_live: "લાઇવ",
        c_now_making: "બની રહ્યું છે:",
        c_your_order: "તમારો ઑર્ડર",
        c_order_again: "🍧 ફરી ઑર્ડર",
        c_items_in_cart: "આઇટમ ઉમેરી",
        c_view_cart: "કાર્ટ જુઓ",

        // Customer STATUS_CONFIG labels & descriptions
        cs_pending_label: "ઑર્ડર મૂક્યો",
        cs_pending_desc: "દુકાન તમારો ઑર્ડર મંજૂર કરે ત્યાં સુધી રાહ જુઓ...",
        cs_approved_label: "✅ મંજૂર!",
        cs_approved_desc: "કૃપા કરી કાઉન્ટર પર આવો અને ચૂકવો 💰",
        cs_paid_label: "💰 ચૂકવ્યા",
        cs_paid_desc: "તમારો ઑર્ડર તૈયાર થઈ રહ્યો છે!",
        cs_preparing_label: "🍧 બનાવાઈ રહ્યું છે.",
        cs_preparing_desc: "તમારો ગોળો તાજો બની રહ્યો છે!",
        cs_ready_label: "🔔 તૈયાર!",
        cs_ready_desc: "ઑર્ડર લઈ જવા આવો!",
        cs_complete_label: "મઝા કરો! 😊",
        cs_complete_desc: "આભાર! ફરી આવો 😊",
        cs_cancelled_label: "✕ રદ",
        cs_cancelled_desc: "દુકાન દ્વારા ઑર્ડર રદ કરવામાં આવ્યો.",

        // Customer cart page
        c_your_cart: "તમારી કાર્ટ",
        c_add_items_btn: "આઇટમ ઉમેરો",
        c_cart_empty: "કાર્ટ ખાલી છે",
        c_your_name_label: "તમારું નામ (ઑર્ડર માટે)",
        c_name_placeholder: "નામ લખો",
        c_place_order_btn: "ઑર્ડર આપો",
        c_placing_order: "ઑર્ડર મૂકાઈ રહ્યો છે...",
        c_pay_note: "💰 મંજૂરી પછી કાઉન્ટર પર ચૂકવો",
    },
};
